module.exports = __webpack_public_path__ + "img/icon-designer-cover.8e6acb66.png";